import { PRNG, randomSeed } from "bitframes";

const seed = randomSeed();
console.log(`[prng-seed]`, seed);
export default PRNG(seed);
